export const companyHeadRoles = [
  'Chief Executive Officer',
  'President',
  'Partner',
  'Owner',
  'Proprietor',
  'Other Detailed Description'
];
